import React from 'react';
import { IconProps } from './types';

const FacebookLogo: React.FC<IconProps> = ({
  className,
  color = '#1877F2',
  size = 32,
  ignoreColor,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 28 28"
    className={className}
  >
    <path
      fill={!ignoreColor ? color : undefined}
      d="M14.001.67C6.64.67.67 6.638.67 14c0 6.654 4.875 12.168 11.25 13.172v-9.317H8.532v-3.855h3.387v-2.937c0-3.344 1.99-5.188 5.034-5.188 1.46 0 2.987.26 2.987.26v3.279h-1.685c-1.654 0-2.17 1.029-2.17 2.084v2.5h3.694l-.59 3.854h-3.105v9.318c6.375-.999 11.25-6.515 11.25-13.17C27.333 6.64 21.363.67 14 .67z"
    />
  </svg>
);

export default FacebookLogo;
